var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer",staticStyle:{"background-color":"#F7F6FE"},attrs:{"fixed":"","padless":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" — Kinetics Technology LTD ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }